export const planUsageTokenStatsRowSx = {
  width: '100%',
  gap: 2.5,
  rowGap: 1.5,
  alignItems: 'flex-start',
}

export const planUsageTokenStatSx = {
  minWidth: 76,
  alignItems: 'flex-start',
}
